<template>
  <div id="app">
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'app',
  computed: {
    ...mapState({
      sysName: state => state.common.setting.sysName,
      
    })
  },
  data() {
    return {

    }
  },
  created() {
    window.document.title = this.sysName;
  },
  // watch: {
  //     '$route'(to, from) {
  //         let path = to.path;
  //         if (path.indexOf('/login') === -1 ){
  //             if (this.$store.state.userInfo.refreshToken == null) {
  //                 var identity = this.$store.state.userInfo.identity || 3;
  //                 var loginUrl = '/login/' + this.$$dataDict.loginType[identity];
  //                 this.$router.push({ path: loginUrl });
  //             }
  //         }
  //     }
  // },
}
</script>

<style lang="scss" >
    @import "base";
</style>
